import {
  ajax
} from 'application/src/js/functions.js';
import {
  SpinnerOverlay
} from 'application/src/js/util.js';

/**
 * @param {ModalWindow} modal
 * @param {node} element
 * @param {Notifications} notify
 */
export default class ModalDeliveryCosts {
  constructor(args) {
    this.modal = args.modal;
    this.notify = args.notify;
    this.translations = translations.modalDeliveryCosts;

    this.container = document.querySelector('.cost-by-city');
    if (!this.container) return;

    this.availableCountriesContainer = this.modal.element.querySelector('.available-countries');
    this.offerId = this.modal.element.getAttribute('data-offer-id');
    this.originCountryId = this.modal.element.getAttribute('data-origin-country-id');
    this.offerType = this.modal.element.getAttribute('data-offer-type');

    this.loader = new SpinnerOverlay({
      targetContainer: this.modal.element.querySelector('.modal-body'),
      position: 'absolute'
    });

    this.openModal = document.querySelectorAll('.open-cities-modal');
    this.calculateButton = document.querySelector('.button-calculate');
    this.priceElement = document.querySelector('.delivery-price');
    this.citySearchField = document.querySelector('.location-search');

    this.countryShort = 'de';
    this.autocomplete = null;
    this.zip = null;
    this.lat = null;
    this.lng = null;
    this.placeID = null;
    this.deliveryData = null;
    this.debugMode = true;

    this.addEvents();
  }

  addEvents() {
    [...this.openModal].map(button => {
      button.addEventListener('click', _ => {
        this.priceElement.innerHTML = '';
        this.availableCountriesContainer.innerHTML = '';
        this.loader.show();
        this.modal.open();
        this.load().then(response => {
          this.countries = response.data.countries;
          this.countryRender();
          this.loader.hide();
        }).catch(e => {
          if (this.debugMode && e) console.log(e);
          this.loader.hide();
        });
      });
    });

    this.calculateButton.addEventListener('click', _ => {
      this.loader.show();
      if (this.citySearchField.value.length) {
        this.loadDeliveryPrice()
          .then(response => {
            this.deliveryData = response.data;
            this.priceRender();
            this.loader.hide();
          }).catch(e => {
            if (this.debugMode && e) console.log(e);
            this.loader.hide();
          });
      } else {
        this.notify.send(this.translations.pleaseEnterCity, 'alert');
      }
    });
  }

  priceRender() {
    this.priceElement.innerHTML = '';
    this.priceElement.innerHTML = this.priceInfoTemplate;
  }

  countryRender() {
    this.availableCountriesContainer.innerHTML = '';
    this.availableCountriesContainer.innerHTML = this.countryTemplate;
    this.selectedCountryDropDown = document.querySelector('#delivery-costs-country');
    this.addEventOnDropDown();
  }

  addEventOnDropDown() {
    this.selectedCountryDropDown.addEventListener('change', e => {
      this.citySearchField.disabled = e.target.value === '';
      this.countryShort = e.currentTarget.value;
      this.citySearchField.value = ''
      this.priceElement.innerHTML = '';
      this.loadGeoData();
    });
  }

  loadGeoData() {
    // Initialise google map place with country restriction
    this.autocomplete = new google.maps.places.Autocomplete(this.citySearchField, {
      types: ['(cities)'],
      componentRestrictions: {
        'country': this.countryShort
      }
    });

    if (this.autocomplete) {
      this.autocomplete.addListener('place_changed', () => {
        let place = this.autocomplete.getPlace();

        if (place.length === 0) return;
        if (typeof place.address_components === 'undefined') return;

        let zip = null;
        let country_short = null;

        place.address_components.map(c => {
          if (c.types.indexOf('postal_code') >= 0) zip = c.long_name;
          if (c.types.indexOf('country') >= 0) country_short = c.short_name;
        });
        this.calculateButton.disabled = false;
        this.zip = zip;

        if (typeof place.geometry === 'undefined') return;

        this.lat = place.geometry.location.lat();
        this.lng = place.geometry.location.lng();
        this.placeID = place.place_id;
      });
    }
  }

  load() {
    return ajax('/mundus-agri/offer/ajaxLoadDeliverableCountry', {
      origincountryid: this.originCountryId
    });
  }

  loadDeliveryPrice() {
    return ajax('/mundus-agri/offer/ajaxLoadCostByplace', {
      offerid: this.offerId,
      type: this.offerType,
      lat: this.lat,
      lng: this.lng,
      place_id: this.placeID,
      zip: this.zip,
      short: this.countryShort
    });
  }

  showLoader() {
    this.loader.style.display = 'flex';
  }

  hideLoader() {
    this.loader.style.display = 'none';
  }

  get countryOptions() {
    return this.countries.reduce((prev, curr) => {
      prev += `<option value="${curr.dest_short}">${curr.country_name}</option>`;
      return prev;
    }, '');
  }

  get countryTemplate() {
    return `
      <div>
        <label for="delivery-costs-country">${this.translations.country}</label>
        <select id="delivery-costs-country">
          <option value="" style="display: none;"></option>
          ${this.countryOptions ? this.countryOptions : ''}
        </select>
      </div>
    `
  }

  get priceInfoTemplate() {
    return `
    <div class="component delivery-info-details">
      <div class="component-header"><span></span></div>
        <div class="component-body">
	        <div class="grid-x grid-margin-x">
            <div class="cell tiny-12 medium-7 labels"> ${this.translations.distance}:</div>
            <div class="cell tiny-12 medium-5">${this.deliveryData.distance ? this.deliveryData.distance : this.translations.noInfo}</div>
          </div>
    	    <div class="grid-x grid-margin-x">
            <div class="cell tiny-12 medium-7 labels">${this.translations.unit}:</div>
            <div class="cell tiny-12 medium-5">${this.deliveryData.unit ? this.deliveryData.unit : this.translations.noInfo}</div>
          </div>
          <div class="grid-x grid-margin-x">
            <div class="cell tiny-12 medium-7 labels"> ${this.translations.deliveryPrice}:</div>
            <div class="cell tiny-12 medium-5">${this.deliveryData.deliveryPrice ? this.deliveryData.deliveryPrice : this.translations.noInfo}</div>
          </div>
          <div class="grid-x grid-margin-x">
            <div class="cell tiny-12 medium-7 labels">${this.translations.co2Balance}:</div>
            <div class="cell tiny-12 medium-5">${this.deliveryData.co2Balance ? this.deliveryData.co2Balance : this.translations.noInfo}</div>
          </div>
        </div>
      </div>

      <div class="component delivery-info-details">
      <div class="component-header"><span>${this.translations.summary}:</span></div>
        <div class="component-body">
          <div class="grid-x grid-margin-x">
            <div class="cell tiny-12 medium-7 labels">${this.translations.offerPrice}:</div>
            <div class="cell tiny-12 medium-5">${this.deliveryData.offerPrice}</div>
          </div>
          <div class="grid-x grid-margin-x">
            <div class="cell tiny-12 medium-7 labels">${this.translations.transportPrice}:</div>
            <div class="cell tiny-12 medium-5">${this.deliveryData.transportPrice}</div>
          </div>
          <div class="grid-x grid-margin-x">
            <div class="cell tiny-12 medium-7 labels">${this.translations.totalTransportPrice}:</div>
            <div class="cell tiny-12 medium-5">${this.deliveryData.totalTransportPrice}</div>
          </div>
        </div>
      </div>
     `
  }
}